import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './FloatingBubbleModal.css';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import API_BASE_URL from '../config';

const FloatingBubbleModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bitacoraData, setBitacoraData] = useState([]);
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'SIN_ESTACION';

  const fetchBitacoraData = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-vuelos`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("📦 Datos crudos de la API:", response.data);
    console.log("📍 Estación del usuario:", estacionUsuario);

    const filtrados = response.data.filter(
      (item) => item.estacion?.trim().toUpperCase() === estacionUsuario
    );

    console.log("✅ Filtrados:", filtrados);

    setBitacoraData(filtrados);
  } catch (error) {
    console.error('Error al obtener la bitácora:', error);
  }
};


  useEffect(() => {
    if (isModalOpen) {
      fetchBitacoraData();
    }
  }, [isModalOpen]);

  return (
    <div>
      <div
        className={`floating-bubble ${isModalOpen ? 'bubble-active' : ''}`}
        onClick={() => setIsModalOpen(!isModalOpen)}
      >
        📋
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal modal-animate-in">
            <div className="modal-header">
              <h2>Bitácora del Día</h2>
              <button className="close-button" onClick={() => setIsModalOpen(false)}>✖</button>
            </div>
            <div className="modal-body">
              <table className="bitacora-table">
                <thead>
                  <tr>
                    <th>No. Fila</th>
                    <th>Siglas</th>
                    <th>Vuelos</th>
                  </tr>
                </thead>
                <tbody>
                  {bitacoraData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.noFila}</td>
                      <td>{item.siglas}</td>
                      <td>
                        <div className="vuelos-wrapper">
                         {item.vuelos.map((vuelo, i) => {
  const status = vuelo.status?.toLowerCase() || 'desconocido';
  return (
    <span
      key={i}
      className={`vuelo-box vuelo-${status}`}
      title={`Vuelo ${vuelo.numero} - ${vuelo.status || 'Sin estado'}`}
    >
      {vuelo.numero}
    </span>
  );
})}


                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingBubbleModal;
